import Upload from '@/components/upload/upload.vue';
import Uploader from '@/components/upload/uploader.vue';
import ImageItem from '@/components/upload/image-item.vue';
import FileUpload from '@/components/upload/file-upload.vue';
import ManuallyUpload from '@/components/upload/manually-upload.vue';

export default Upload;
export {
  Uploader, ImageItem, FileUpload, ManuallyUpload,
};
